<template>
    <div v-click-outside="closeDropdown" class="u-pos-relative c-customer-search" :class="{'is-open' : open}">
        <slot name="labelText"><h5 v-if="impersonate" class="u-text-uppercase" v-html="$t('customer.impersonate.label')"></h5></slot>

        <v-input :horizontal="true"
                 autocomplete="off"
                 :placeholder= "$t('customer.impersonate.placeholder')"
                 :aria-expanded="`${open ? 'true' : 'false'}`"
                 :fluid="true"
                 custom-class="c-customer-search__input"
                 type="search"
                 :name="`${_uid}-customer-search`"
                 v-model="search"
                 :debounce-delay="0"
                 @focus="openDropdown">

            <slot slot="dropdown">
                <transition name="loading">
                    <v-loader class="c-customer-search__loader" :class="{'is-visible': loading}" v-show="loading" type="circle" size="small"></v-loader>
                </transition>

                <div class="c-customer-search-dropdown" v-if="open && !loading">
                    <div v-if="suggestions.length === 0 && !loading" class="u-font-medium u-text-align-center u-padding">{{ $t('global.no_results') }}</div>
                    <ul class="c-customer-search-results-list" role="listbox" aria-autocomplete="both">
                        <li v-for="item in suggestions" :key="item.Id" class="c-customer-search-line--group c-customer-search-line">
                            <div v-if="impersonate" class="c-customer-search__item c-customer-search__item--group">
                                <span class="c-customer-search-item__name">{{item.Name}} <span class="u-font-tiny u-font-italic">({{item.AltKey}})</span></span>
                                <v-customer-search-add @change="impersonateUser(item)" name="item" :item.sync="item" color="alpha"></v-customer-search-add>
                            </div>
                            <div v-else @click="selected(item)" class="c-customer-search__item c-customer-search__item--group c-customer-search__item--click">
                                <span class="c-customer-search-item__name">{{item.Name}} <span class="u-font-tiny u-font-italic">({{item.AltKey}})</span></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </slot>
            <slot slot="suffix">
                <button v-if="!impersonate" type="button" @click="clear" class="c-button c-button--dropdown c-button--icon-only c-button--small c-button--alpha">
                    <svgicon name="cross"></svgicon>
                </button>
            </slot>
        </v-input>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VInput from '@/components/form/Input'
    import VCustomerSearchAdd from './widgets/Add'
    import vClickOutside from 'v-click-outside';
    import VLoader from '@/components/loader/Loader';

    // Register outside Click plugin
    Vue.use(vClickOutside);

    export default {
        props: {
            options: Array,
            impersonate: { type: Boolean, default: true },
            preSearch: { type: String, default: ''}
        },
        components: {
            VCustomerSearchAdd,
            VInput,
            VLoader,
        },
        data() {
            return {
                localOptions: this.options,
                focus: false,
                loading: false,
                close: false,
                search: '',
                suggestions: []
            }
        },
        computed: {
            open: {
                get() {
                    return String(this.search).length >= 3 && this.focus && !this.close;
                },
                set(value) {
                    return value;
                }
            }
        },
        watch: {
            preSearch(newVal) {
                this.search = newVal;
            },
            search() {
                if (String(this.search).length >= 1) {
                    this.loading = true;
                    this.$store.dispatch('getCustomerOptions', {
                        params: {
                            search: this.search
                        }
                    }).then((customers) => {
                        this.suggestions = customers;
                        this.loading = false;
                    });
                }
            }
        },
        methods: {
            openDropdown() {
                this.focus = true;
                this.close = false;
            },
            closeDropdown() {
                this.close = true;
            },
            impersonateUser(user) {
                this.$store.dispatch('impersonateUser', user.Id).then((user) => {
                    this.$store.dispatch('checkAuth');
                    this.$router.push("/customer")
                }).catch((e) => {
                    this.$notify({
                        group: 'global',
                        title: e.Message,
                        type: 'error',
                        duration: 4000
                    });
                });
            },

            selected(user) {
                this.$emit(`selected`, user);
                this.search = user.Name;
                this.close = true;
            },
            clear() {
                this.$emit(`clear`);
                this.search = '';
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-customer-search__item--click {
        cursor: pointer;
    }

    .c-button--dropdown {
        margin: 0 0 0 -7px;
        height: 41px;
    }
</style>



// WEBPACK FOOTER //
// src/components/form/customerSearch/CustomerSearch.vue